import BackgroundSection from "./backgroundSection/BackgroundSection";
import AboutsClinicSection from "./aboutsClinicSection/AboutsClinicSection";
import ReviewsSection from "./reviewsSection/ReviewsSection";
import FeedbackSection from "../contactsPage/ feedbackSection/FeedbackSection";

const ReviewsPage = () => {
    return(
        <div>
            <BackgroundSection/>
            <AboutsClinicSection/>
            <ReviewsSection/>
            <FeedbackSection/>
        </div>
    )
}
export default ReviewsPage;